import { getData } from './getData'

export const TransactionController = {
  getData,
}
